const NoBooksIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="211" height="277" viewBox="0 0 211 277" fill="none">
      <rect
        x="0.25"
        y="0.25"
        width="210.5"
        height="276.5"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="0.5"
      />
      <path
        d="M128.795 127.605C127.727 127.064 126.614 126.612 125.455 126.229V153.373C122.864 152.448 120.205 151.974 117.5 151.974C113.182 151.974 108.909 153.193 105 155.539V128.237C101.318 126.138 97.0682 124.897 92.5 124.897C88.4318 124.897 84.5909 125.89 81.2045 127.605C80.4545 127.966 80 128.756 80 129.591V156.848C80 158.157 81.0682 159.082 82.2727 159.082C82.6364 159.082 83 158.992 83.3636 158.811C86.1136 157.39 89.2045 156.487 92.5 156.487C97.2045 156.487 101.545 158.337 105 161C108.455 158.337 112.795 156.487 117.5 156.487C120.795 156.487 123.886 157.39 126.636 158.834C127 159.014 127.364 159.105 127.727 159.105C128.909 159.105 130 158.179 130 156.871V129.591C130 128.756 129.545 127.966 128.795 127.605ZM100.455 153.373C97.8636 152.448 95.2045 151.974 92.5 151.974C89.7955 151.974 87.1364 152.448 84.5455 153.373V131.012C87.0682 129.952 89.7273 129.41 92.5 129.41C95.2273 129.41 97.9318 129.974 100.455 131.035V153.373ZM120.909 117L109.545 128.282V149.718L120.909 139.564V117Z"
        fill="currentColor"
        fillOpacity="0.6"
      />
    </svg>
  );
};

export default NoBooksIcon;
